var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',{attrs:{"title":_vm.$t('title')}}),_c('related-address-section',{attrs:{"empty-message":_vm.$t('emptyMessage'),"relation-type":_vm.ADDRESS_RELATION_TYPE_KONTAKT}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }